import {
	type Steps,
	type GetSteps,
	type IncludedQuestions,
} from '#types/form/wizard.ts'

const getIncludedQuestions = (
	includedQuestions: IncludedQuestions[],
): string[] => {
	return includedQuestions.reduce((acc: string[], curr: IncludedQuestions) => {
		return acc.concat(curr.includedQuestions)
	}, [])
}

interface FilteredStepsParams<T> {
	GetSteps: GetSteps<T>
	includedControllerQuestions: IncludedQuestions[]
}
export function filteredSteps<T>({
	GetSteps,
	includedControllerQuestions,
}: FilteredStepsParams<T>): () => Steps<T>[] {
	return () => {
		return GetSteps().filter((step: Steps<T>) => {
			if (step.needsToBeIncludedByController) {
				const allIncludedQuestions = getIncludedQuestions(
					includedControllerQuestions,
				)

				const stepIdWithoutSuffix = step.id.replace(/-\d+$/, '')

				return allIncludedQuestions.includes(stepIdWithoutSuffix)
			}

			return true
		})
	}
}
